import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import store from "@beeldit/core/services/store";
import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";

function PricePerDaysInput(props: any) {
  const { t } = useTranslation();
  const {
    id,
    value,
    required,
    disabled,
    readonly,
    onChange,
    placeholder,
    schema,
    formContext,
  } = props;

  // Estado local para manejar el valor del input
  const [inputValue, setInputValue] = useState(value);

  const errorHandler = useErrorHandler();

  const { element, setElement } = formContext;

  const [lastPetIds, setLastPetIds] = useState([]);
  const [lastCustomerId, setLastCustomerId] = useState(null);
  const [lastRooms, setLastRooms] = useState([]);

  // Crear una versión debounced de la función onChange
  const debouncedOnChange = useCallback(
    (value: any) => {
      const handler = setTimeout(() => {
        onChange(value);
      }, 500); // Espera 0.5 segundos antes de invocar onChange

      // Limpieza: Clear the timeout if the component is unmounted or the value changes
      return () => {
        clearTimeout(handler);
      };
    },
    [onChange] // Re-crear esta función si onChange cambia
  );

  // Efecto para manejar cambios en inputValue
  useEffect(() => {
    // Llama a la función debounced cada vez que inputValue cambie
    const handler = debouncedOnChange(inputValue);

    // Limpieza: asegúrate de limpiar el timeout si el componente se desmonta
    return () => {
      if (handler) handler();
    };
  }, [inputValue, debouncedOnChange]);

  useEffect(() => {
    if (!element?.pets?.length || !element?.rooms?.length) {
      setElement((prevElement: any) => ({
        ...prevElement,
        price_per_day: 0,
      }));
    } else {
      // Si no ha habido cambios en pets o rooms, no se hace la petición, para así mantener el  valor que hubiera guardado
      if (
        JSON.stringify(element.pets) === JSON.stringify(lastPetIds) &&
        JSON.stringify(element.rooms) === JSON.stringify(lastRooms) &&
        element.customer_id === lastCustomerId
      ) {
        return;
      }
      const data = {
        pets: element.pets,
        rooms: element.rooms,
        customer_id: element.customer_id,
        booking_id: element.id
      }
      store("bookings/get-price-per-day", data)
      .then((response: any) => {
        const pricePerDay = response.data.price_per_day;
        setElement((prevElement: any) => ({
          ...prevElement,
          price_per_day: pricePerDay,
        }));        
      })
      .catch((error: any) => {
        errorHandler(error, null);
      });
    }
    setLastPetIds(element.pets);
    setLastRooms(element.rooms);
    setLastCustomerId(element.customer_id);
    
  }, [element.pets, element.rooms]);

  // Efecto para manejar cambios externos en 'value' prop
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <>
      <br />
      <input
        id={id}
        className="form-control"
        type={schema.type}
        value={inputValue}
        min={schema.minimum}
        max={schema.maximum}
        required={required}
        disabled={disabled}
        readOnly={readonly}
        placeholder={placeholder}
        onChange={(event) => setInputValue(event.target.value)}
      />
    </>
  );
}

export default PricePerDaysInput;
